import LangUtils from "@/utils/LangUtils";
import MapElement from "./MapElement";

export default class MapObjectLayer extends MapElement {
    constructor(mapObject, language) {
        var idToUse = mapObject.id;
        if (!idToUse) {
            idToUse = LangUtils.valueForLanguage(mapObject.name, "en");
        }

        super(idToUse, mapObject.hidden);

        this.mapObject = mapObject;
        this.language = language;
    }

    getName() {
        if (this.mapObject.name) {
            return LangUtils.valueForLanguage(this.mapObject.name, this.language);
        } else {
            return "";
        }
    }

    getType() {
        return this.mapObject.type;
    }

    getIconFileName() {
        return this.mapObject.iconFileName
    }

    isHideable() {
        return this.mapObject.hideable;
    }

    getTags() {
        return this.mapObject.tags;
    }    
}
